import React from "react";
import { makeStyles } from "@mui/styles";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  formTitle: {
    color: theme.palette.primary.main,
  },
  formTitleError: {
    color: theme.palette.error.main,
  },
  select: {
    color: theme.palette.primary.copy,
    "&:before": {
      borderColor: theme.palette.primary.main,
    },
    "&:after": {
      borderColor: theme.palette.primary.main,
    },
  },
  selectError: {
    "&:before": {
      borderColor: theme.palette.error.main,
    },
    "&:after": {
      borderColor: theme.palette.error.main,
    },
  },
  copy: {
    color: theme.palette.primary.copy,
  },
}));

export default function DropdownComponent({
  currValue,
  items,
  handleChange,
  property,
  title,
  multi,
  error,
  emptyRow,
}) {
  const classes = useStyles();

  const changeValue = (event) => {
    handleChange(event.target.value);
  };

  return (
    <FormControl variant="standard" className={classes.formControl}>
      <InputLabel
        className={error ? classes.formTitleError : classes.formTitle}
      >
        {title}
      </InputLabel>
      <Select
        variant="standard"
        value={currValue}
        onChange={changeValue}
        className={error ? classes.selectError : classes.select}
        multiple={multi === undefined ? false : multi}>
        {emptyRow ? <MenuItem value="">&nbsp;</MenuItem> : null}
        {items.map((item, index) => {
          return (
            <MenuItem value={item} key={index} className={classes.copy}>
              {item[property]}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
